export enum AllowedTradeType {
    Partial = 1,
    AllOrNone = 2,
}